import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login'
import Main from '@/pages/Main'
import HomePage from '@/pages/HomePage'
import TradeManage from '@/pages/TradeManagement'
import IndexShow from '@/pages/AssetManagement/IndexShow'
import Asset from '@/pages/AssetManagement/AssetIndex'
import dinner from '@/pages/AssetManagement/CustomersDinner'
import Withdraw from '@/pages/AssetManagement/WithdrawCrash'
import WithdrawOne from '@/components/Withdraw1'
import WithdrawTwo from '@/components/Withdraw2'
import WithdrawThree from '@/components/Withdraw3'
import WithdrawFour from '@/components/Withdraw4'
import WithdrawFive from '@/components/Withdraw5'
import WithdrawSix from '@/components/Withdraw6'
import WithdrawError from '@/components/WithdrawError'
import ManageMems from '@/components/ManageMems'
import Hasbeenon from '@/pages/Hasbeenon'
import storeList from '@/pages/store/storeList'
import addStore from '@/pages/store/addStore'
import preSellList from '@/pages/store/preSellList'
import Noton from '@/pages/Noton'
import roots from '@/components/roots'
import Edit from '@/components/edit'
import NotonList from '@/pages/store/notonList'
import seckill from '@/pages/seckill/index'
import addSeckill from '@/pages/seckill/addSeckill'
import seckillList from '@/pages/seckill/seckillList'
import editSeckill from '@/pages/seckill/editSeckill'
import videoShop from '@/pages/videoShop/index'
import videoList from '@/pages/videoShop/videoShop'
import addVideo from '@/pages/videoShop/addVideo'
import redPacket from '@/pages/redPacket/redPacket'
import shopManage from '@/pages/shopManage/index'
import decoration from '@/pages/shopManage/decoration'
// import staffManagement from '@/pages/shopManage/staffManagement'
// import roleManagement from '@/pages/shopManage/role'


Vue.use(Router)

let router = new Router({
  routes: [{
    path: '/',
    redirect: '/main'
  },
  {
    path: '/login',
    name: '登录',
    component: Login
  },
  {
    path: '/main',
    component: Main,
    children: [{
      path: '',
      name: '首页',
      component: HomePage
    },
    {
      path: 'trademanage',
      name: '交易管理',
      component: TradeManage
    },
    {
      path: 'managemems',
      name: '人员管理',
      component: ManageMems
    },
    {
      path: 'dinner',
      name: '客户用餐',
      component: dinner
    },
    {
      path: 'indexshow',
      component: IndexShow,
      children: [{
        path: '',
        name: '资产管理',
        component: Asset
      },
      {
        path: 'withdraw',
        component: Withdraw,
        children: [{
          path: '',
          name: 'step1',
          component: WithdrawOne
        },
        {
          path: 'WithdrawTwo',
          name: 'step2',
          component: WithdrawTwo
        },
        {
          path: 'WithdrawThree',
          name: 'step3',
          component: WithdrawThree
        },
        {
          path: 'WithdrawFour',
          name: 'step4',
          component: WithdrawFour
        },
        {
          path: 'WithdrawFive',
          name: 'step5',
          component: WithdrawFive
        },
        {
          path: 'WithdrawSix',
          name: 'step6',
          component: WithdrawSix
        },
        {
          path: 'WithdrawError',
          name: 'stepError',
          component: WithdrawError
        }]
      }]
    },
    {
      path: 'storeUp',
      name: '商品上架',
      component: Hasbeenon,
      children: [
        {
          path: '',
          name: '商品上架',
          component: storeList
        }, {
          path: 'addStore',
          name: '添加商品',
          component: addStore
        },
        {
          path: 'roots',
          name: 'Roots',
          component: roots
        },
        {
          path: 'edit',
          name: 'Edits',
          component: Edit
        }
      ]
    },
    {
      path: 'storeDown',
      name: '商品下架',
      component: Noton,
      children: [
        {
          path: '',
          name: '商品下架',
          component: NotonList
        }
      ]
    },
    {
      path: 'preSellList',
      name: '预售商品',
      component: preSellList
      // children: [
      //   {
      //     path: '',
      //     name: '商品下架',
      //     component: NotonList
      //   }
      // ]
    },
    {
      path: 'seckill',
      name: '秒杀',
      component: seckill,
      children: [
        {
          path: '',
          name: '秒杀',
          component: seckillList
        },
        {
          path: 'addSeckill',
          name: '秒杀',
          component: addSeckill
        },
        {
          path: 'editSeckill',
          name: '秒杀',
          component: editSeckill
        }
      ]
    },
    {
      path: 'videoShop',
      name: '视频购',
      component: videoShop,
      children: [
        {
          path: '',
          name: '视频购',
          component: videoList
        },
        {
          path: 'addVideo',
          name: '视频购',
          component: addVideo
        }
      ]
    },
    {
      path: 'redPacket',
      name: '实物红包',
      component: redPacket,
    },
    {
      path: 'shopManage',
      name: '店铺管理',
      component: shopManage,
      children: [
        {
          path: '',
          name: '店铺装修',
          component: decoration
        }
      ]
    },
    // {
    //   path:'staffManagement',
    //   name:'员工管理 ',
    //   component:staffManagement 
    // },
    // {
    //   path:'roleManagement',
    //   name:'角色管理',
    //   component:roleManagement,
    // }
    ]
  },]
})
const whiteList = ['/', '/login']
router.beforeEach((to, from, next) => {
  const {
    path
  } = to
  if (whiteList.indexOf(path) > -1) {
    next()
  } else {
    if (localStorage.getItem('info') && JSON.parse(localStorage.getItem('info')).isLogin) {
      next()
    } else {
      next('/login')
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js